import React, { FC } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { IconButton, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
type Props = {
  disabled: boolean;
  onClick: () => void;
  caption: string;
};
export const ExportButton: FC<Props> = ({ disabled, onClick, caption }) => {
  const theme = useTheme();
  const getStyles = () => {
    let styles = {
      backgroundColor: theme.palette.foreColor.main,
      color: "#000",

      fontSize: 16,
      height: 30,
      // marginBottom: 16,
      width: 30,
      boxShadow: "3px 3px 8px 1px #202226",
      transition: "all 0.3s",
      "&:hover": {
        backgroundColor: theme.palette.foreColor.light,
        color: "#37393F",
        boxShadow: "none",
        transform: "translate(3px, 3px)",
      },
    };
    return styles;
  };
  return (
    <IconButton
      component="label"
      disabled={disabled}
      onClick={onClick}
      sx={getStyles()}
    >
      <Tooltip title={caption} placement="bottom">
        <DownloadIcon />
      </Tooltip>
    </IconButton>
  );
};
